import { render, staticRenderFns } from "./PagamentoServicos.vue?vue&type=template&id=c0250e70&scoped=true&"
import script from "./PagamentoServicos.vue?vue&type=script&lang=js&"
export * from "./PagamentoServicos.vue?vue&type=script&lang=js&"
import style0 from "./PagamentoServicos.vue?vue&type=style&index=0&id=c0250e70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0250e70",
  null
  
)

export default component.exports